import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  Table,
  Column,
  Button,
  Input,
  FormGroup,
  Select,
} from '@tencent/spaui';
import { SelectTree } from '@tencent/spaui-business';
import IndustrySelect from '@/business-components/sale/IndustrySelect';
import AreaSelect from '@/business-components/sale/AreaSelect';
import CustomerPanel from '@/business-components/sale/customers/CustomerPanel';
import LeadReplenish from '@/business-components/sale/customers/LeadReplenish';
import AccountPanel from '@/business-components/sale/customers/AccountPanel';
import ActionRecordPanel from '@/pages/leads/actionRecords/ActionRecordPanel';
import DockedDialog from '@/components/DockedDialog';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import ContactPanel from '@/business-components/sale/customers/ContactPanel';
import CustomerFollowUpRecord from '@/business-components/sale/customers/CustomerFollowUpRecord';
import { isContain } from '@/utils/ParamUtils';
import fePerms from '@/common/permissions/sale/fePerms';
import MessageBox from '@/components/MessageBox';
import perms from '@/common/permissions/sale/perms';
import { withAccount } from '@/business-components/operator/account-context';
import { getQuery } from '@/utils';

class PotentialDetails extends React.Component {
  static propTypes = {
    // show: PropTypes.bool,
    // onClose: PropTypes.func,
    // onSubmit: PropTypes.func,
    // onCancel: PropTypes.func,
    match: PropTypes.shape({
      params: PropTypes.shape({
        leadId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    potential: PropTypes.object,
  };
  state = {};
  componentDidMount() {
    const { potential } = this.props;
    // if (!potential) {
    this.fetchPotential();
    // }
  }

  fetchPotential = () => {
    const { webApi, id } = this.props;
    const leadId = this.props.match?.params?.leadId || id;
    const agencyId = getQuery('agencyId');
    webApi
      .getPotential(leadId, agencyId)
      .dispatchJson(ActionTypes.FETCH_POTENTIAL)
      .then((res) => {
        this.setState({ potential: res });
      })
      .catch((error) => {
        this.context.error('商机详情获取失败', error.message);
      });
  };

  render() {
    const { hide } = this.props;
    const { potential } = this.state;
    if (!potential) {
      return null;
    }

    // 是否可以编辑
    const readOnly = !isContain(potential.permissions, fePerms.POTENTIAL_EDIT);
    return (
      <DockedDialog
        show={!hide}
        className="PotentialDetails"
        title="商机详情"
        escHide={true}
        cancelButton={false}
        submitLabel={'关闭'}
        onSubmit={this.handleSubmit}
        onClose={this.handleClose}
        onCancel={this.handleClose}
      >
        {this.renderCustomerInfo(potential, readOnly)}
        {this.renderLeadReplenish(potential, readOnly)}
        {this.renderContactList(potential, readOnly)}
        {this.renderAccountInfo(potential)}
        {this.renderCustomerFollowUpRecord(potential)}
        {this.renderActionRecordList(potential, readOnly)}
        {/*{this.renderOrderInfo(potential)}*/}
      </DockedDialog>
    );
  }

  renderCustomerInfo(potential, readOnly) {
    return (
      <CustomerPanel
        showCheckNewCustom
        detail={potential}
        ascriptionOwnerId={potential.ownerId}
        ascriptionTeamId={potential.potentialAscriptionTeamId}
        lead={potential.lead}
        readOnly={readOnly}
        onEdit={this.handleEdit}
        callback={this.fetchPotential}
      />
    );
  }

  renderLeadReplenish(potential, readOnly) {
    return <LeadReplenish detail={potential} />;
  }

  renderAccountInfo(potential) {
    return (
      <AccountPanel
        detail={potential}
        lead={potential.lead}
        callback={this.fetchPotential}
        supportWx
      />
    );
  }

  renderContactList(potential, readOnly) {
    return (
      <ContactPanel
        lead={{ ...potential.lead, additionalLeads: potential.additionalLeads }}
        readOnly={true}
        getDetail={this.fetchPotential}
        editPerm={!readOnly}
      />
    );
  }

  /**
   * @description: 客保跟进记录
   */
  renderCustomerFollowUpRecord = (potential) => {
    return <CustomerFollowUpRecord lead={potential.lead} />;
  };

  renderActionRecordList(potential, readOnly) {
    const { account } = this.props;
    return (
      <ActionRecordPanel
        lead={potential.lead}
        version={potential.version}
        permissions={potential.permissions}
        potential={potential}
        readOnly={readOnly}
        onChange={this.fetchPotential}
      />
    );
  }

  // renderOrderInfo(potential) {
  //   return (
  //     <div className={"OrderInfo"}>
  //       <h2>提单信息</h2>
  //       <form className="form-inline">
  //         <FormGroup className="required">
  //           <label>首次到款金额：</label>
  //           <Input/>
  //         </FormGroup>
  //       </form>
  //     </div>
  //   );
  // }

  handleEdit = () => {
    const { history } = this.props;
    const pathname = history.location.pathname;
    history.push({ pathname: pathname + '/edit' });
  };

  handleSubmit = () => {
    this.handleClose();
  };

  handleClose = () => {
    if (this.props.handleClose) {
      return this.props.handleClose();
    }
    const { history } = this.props;
    const pathname = history.location.pathname;
    history.push({ pathname: pathname.substr(0, pathname.lastIndexOf('/')) });
  };
}

function mapStateToProps(state, ownProps) {
  const { id } = ownProps;
  const leadId = ownProps.match?.params?.leadId || id;
  return {
    potential: state.potentialRepo[leadId],
  };
}

export default withApi(withAccount(connect(mapStateToProps)(PotentialDetails)));

PotentialDetails.contextType = MessageBox;
